import { render, staticRenderFns } from "./InstallationSettings.vue?vue&type=template&id=436d31e8"
import script from "./InstallationSettings.vue?vue&type=script&lang=js"
export * from "./InstallationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports